import * as angular from "angular";

angular
  .module('triangular.themes', []);
